query MfaUsageData(
	$daysAmountFilter: ConditionInt
	$daysAmountx2Filter: ConditionInt
	$textSearch: mfa_session_runsSearchInsensitive
	$createdByFilter: ConditionString
	$customFieldsFilter: ConditionStringArray
	$osFilter: ConditionStringArray
	$appFilter: ConditionStringArray
	$appVersionFilter: ConditionStringArray
) {
	last_n_days: mfa_session_runs(
		run_time_last_n_days: $daysAmountFilter
		text_contains: $textSearch
		user_name_eq: $createdByFilter
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq_any_item_for_any_value: $osFilter
		app_eq_any_item_for_any_value: $appFilter
		app_version_eq_any_item_for_any_value: $appVersionFilter
	) {
		run_id_count
		total_scans_sum
		critical_issues_sum
		user_name_group_uniq_array
	}
	last_2n_days: mfa_session_runs(
		run_time_last_n_days: $daysAmountx2Filter
		text_contains: $textSearch
		user_name_eq: $createdByFilter
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq_any_item_for_any_value: $osFilter
		app_eq_any_item_for_any_value: $appFilter
		app_version_eq_any_item_for_any_value: $appVersionFilter
	) {
		run_id_count
		total_scans_sum
		critical_issues_sum
		user_name_group_uniq_array
	}

}
